import InfiniteScroll from 'react-infinite-scroll-component';

import { StyledLoader } from '../../../../styled';
import { Option } from '../../../../types';
import { StyledCheckbox } from '../../../StyledCheckbox/styled';
import { highlightSearch, isElementInArray } from '../../utils';
import { EmptyView, StyledCheckboxWrapper, StyledDownloadMoreLoader, StyledLink, StyledListWrapper } from '../styled';
import { countHeightForList } from './utils';

type Props = {
  selectedItems: Option[];
  loading: boolean;
  allItems: Option[];
  searchValue?: string;
  showSelectAll?: boolean;
  onNextPage?: () => void;
  handleSelectAll: () => void;
  handleUnselectAll: () => void;
  total: number;
  maxSelectedItemsCount: number;
  handleSelectItem: (item: Option) => void;
};

const List = ({
  selectedItems,
  allItems,
  loading,
  showSelectAll,
  onNextPage,
  handleSelectAll,
  handleUnselectAll,
  handleSelectItem,
  searchValue,
  total,
  maxSelectedItemsCount,
}: Props): JSX.Element => {
  if (loading) {
    return <StyledLoader data-testid="list-loader" />;
  }

  if (total === 0) {
    return <EmptyView data-testid="empty-list">No items found</EmptyView>;
  }

  const isMaxReached = selectedItems.length >= maxSelectedItemsCount;

  const selectedItemIds = selectedItems.map((item) => item.value);
  const allListItemsSelected = allItems.every((item) => selectedItemIds.includes(item.value));

  const handleSelectAllClick = (): void => {
    if (!allListItemsSelected) {
      handleSelectAll();
    } else {
      handleUnselectAll();
    }
  };
  return (
    <StyledListWrapper data-testid="listWrapper">
      <InfiniteScroll
        data-testid="list-wrapper"
        next={onNextPage || ((): void => {})}
        height={countHeightForList(allItems.length)}
        dataLength={allItems.length}
        loader={<StyledDownloadMoreLoader />}
        hasMore={allItems.length < total}
      >
        {showSelectAll && (
          <StyledLink data-testid="selectDeselectAll" onClick={handleSelectAllClick}>
            {allListItemsSelected ? <span>Deselect All</span> : <span>Select All</span>}
          </StyledLink>
        )}
        {allItems.map((el) => (
          <StyledCheckboxWrapper key={el.value}>
            <StyledCheckbox
              data-testid="checkbox"
              disabled={isMaxReached && !isElementInArray(el, selectedItems)}
              checked={isElementInArray(el, selectedItems)}
              onChange={(): void => handleSelectItem(el)}
              label={highlightSearch(el.label, searchValue || '')}
            />
          </StyledCheckboxWrapper>
        ))}
      </InfiniteScroll>
    </StyledListWrapper>
  );
};

export default List;
